(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'FooterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }],
                roundInfo: ['GpmRoundOpen', function (GpmRoundOpen) {
                    return GpmRoundOpen.get({
                        'typeFilter': 'regular'
                    }).$promise;
                }],
                allRoundsInfo: ['GpmAllRoundsOpen', function (GpmAllRoundsOpen) {
                    return GpmAllRoundsOpen.query().$promise;
                }]
            }
        });
    }
})();
